import { TestIdDomain } from 'constants/testIds';

const loanManagementTestIdsScope = {
  CONTENT_VIEW: 'content-view',
};

export const loanManagementTestIds = {
  // LoanActionEmailRow
  LOAN_MANAGEMENT_FORM_SUBJECT_INPUT: `${TestIdDomain.LOAN_MANAGEMENT}.subject-input`,

  // LoanActionItem
  LOAN_MANAGEMENT_FORM_HOURS_INPUT: `${TestIdDomain.LOAN_MANAGEMENT}.hours-input`,
  LOAN_MANAGEMENT_FORM_MINUTES_INPUT: `${TestIdDomain.LOAN_MANAGEMENT}.minutes-input`,

  // LoanActionRow
  LOAN_MANAGEMENT_FORM_ENABLE_PREVIEW_CHECKBOX: `${TestIdDomain.LOAN_MANAGEMENT}.enable-preview-checkbox`,
  LOAN_MANAGEMENT_FORM_IS_TEST_CHECKBOX: `${TestIdDomain.LOAN_MANAGEMENT}.is-test-checkbox`,
  LOAN_MANAGEMENT_FORM_REQUIRES_APPROVAL_CHECKBOX: `${TestIdDomain.LOAN_MANAGEMENT}.requires-approval-checkbox`,

  // LoanActionVariableFieldRow
  LOAN_MANAGEMENT_FORM_IS_REQUIRED_CHECKBOX: `${TestIdDomain.LOAN_MANAGEMENT}.is-required-checkbox`,

  // Dynamic
  getContentViewGroupId: index => `${loanManagementTestIdsScope.CONTENT_VIEW}.group-${index}`,
  getContentViewRowId: index => `${loanManagementTestIdsScope.CONTENT_VIEW}.row-${index}`,

  // LoanActionItem (inline)
  CONTENT_VIEW_ADD_ACTION_ITEM: `${loanManagementTestIdsScope.CONTENT_VIEW}.add-action-item`,

  // LoanActionClosingPortalAccessRow (inline)
  CONTENT_VIEW_EMAIL_EXPRESSION_INPUT: `${loanManagementTestIdsScope.CONTENT_VIEW}.email-expression-input`,

  // LoanActionSavePendingChangesPermissionRow
  getSavePendingChangesExpressionInputId: fieldPath => `${fieldPath}.expression-input`,
  getSavePendingChangesCanCancelCheckboxId: fieldPath => `${fieldPath}.can-cancel-checkbox`,
  getSavePendingChangesCanSaveCheckboxId: fieldPath => `${fieldPath}.can-save-checkbox`,
  getSavePendingChangesCanViewOthersCheckboxId: fieldPath =>
    `${fieldPath}.can-view-others-checkbox`,

  // DynamicValueInput (LoanActionItems)
  getDynamicValueInputId: name => `${TestIdDomain.LOAN_MANAGEMENT}.${name}-input`,
  getDynamicValueOptionId: name => `${TestIdDomain.LOAN_MANAGEMENT}.${name}-option`,
  getDynamicValueSelectId: name => `${TestIdDomain.LOAN_MANAGEMENT}.${name}-select`,
  getDynamicValueCheckboxId: name => `${TestIdDomain.LOAN_MANAGEMENT}.${name}-checkbox`,

  // Mapped row controls (keyed by the row's field path)
  getDeleteRowButtonId: fieldPath => `${fieldPath}.delete-button`,
  getAddSupportingDocumentButtonId: fieldPath => `${fieldPath}.add-supporting-document-button`,
  getAllowManualSelectionSwitchId: fieldPath => `${fieldPath}.allow-manual-selection-switch`,
  getSendNotificationSwitchId: fieldPath => `${fieldPath}.send-notification-switch`,
  getAllowUserSelectionSwitchId: fieldPath => `${fieldPath}.allow-user-selection-switch`,

  // LoanActionFloodServiceRow
  getFloodPromptAtExecutionSwitchId: fieldPath => `${fieldPath}.prompt-at-execution-switch`,
  getFloodRushSwitchId: fieldPath => `${fieldPath}.rush-switch`,
  getMersToggleSwitchId: fieldPath => `${fieldPath}.mers-toggle-switch`,

  // LoanActionItem (per-action controls)
  getCustomStopConditionSwitchId: actionIndex =>
    `${loanManagementTestIdsScope.CONTENT_VIEW}.custom-stop-condition-switch-${actionIndex}`,
  getDeleteActionButtonId: actionIndex =>
    `${loanManagementTestIdsScope.CONTENT_VIEW}.delete-action-button-${actionIndex}`,

  // LoanActionIntegrationRow
  getIntegrationPackageSelectId: rootPath => `${rootPath}.package-select`,
  getIntegrationMethodSelectId: rootPath => `${rootPath}.method-select`,
  getIntegrationEnvironmentSelectId: rootPath => `${rootPath}.environment-select`,

  // LoanActionSnapdocsRow
  getSnapdocsSigningMethodSelectId: rootPath => `${rootPath}.signing-method-select`,
  getSnapdocsBrandingKeyInputId: rootPath => `${rootPath}.branding-key-input`,
  getSnapdocsDocumentTypesSelectId: rootPath => `${rootPath}.document-types-select`,
  getSnapdocsScanbacksRequiredCheckboxId: rootPath => `${rootPath}.scanbacks-required-checkbox`,
  getSnapdocsDocumentReturnMethodSelectId: rootPath => `${rootPath}.document-return-method-select`,
  getSnapdocsInstructionsInputId: rootPath => `${rootPath}.instructions-input`,
  getSnapdocsCommentTextInputId: rootPath => `${rootPath}.comment-text-input`,
  getSnapdocsSettlementAgentVisibleCheckboxId: rootPath =>
    `${rootPath}.settlement-agent-visible-checkbox`,
  getSnapdocsConsumerVisibleCheckboxId: rootPath => `${rootPath}.consumer-visible-checkbox`,
  getSnapdocsOptOutReasonInputId: rootPath => `${rootPath}.opt-out-reason-input`,
  getSnapdocsPromptAtExecutionCheckboxId: rootPath => `${rootPath}.prompt-at-execution-checkbox`,
  // LoanActionMortgageInsuranceRow
  getMortgageInsuranceProviderSelectId: rootPath => `${rootPath}.provider-select`,
  getMortgageInsuranceApplicationTypeSelectId: rootPath => `${rootPath}.application-type-select`,
  getMortgageInsuranceResubmissionCheckboxId: rootPath => `${rootPath}.resubmission-checkbox`,

  // LoanActionReportRow (Credit report)
  getCreditBureauCheckboxId: (fieldPath, bureauKey) =>
    `${fieldPath}.credit-bureau-${bureauKey}-checkbox`,
  getCreditManualSelectionSwitchId: fieldPath => `${fieldPath}.credit-manual-selection-switch`,

  // LoanActionReportRow (Halcyon tax transcript)
  CONTENT_VIEW_HALCYON_BORROWER_EXPRESSION_INPUT: `${loanManagementTestIdsScope.CONTENT_VIEW}.halcyon-borrower-expression-input`,
  getHalcyonManualSelectionSwitchId: fieldPath => `${fieldPath}.halcyon-manual-selection-switch`,
  getHalcyonNonProdCredentialsSwitchId: fieldPath =>
    `${fieldPath}.halcyon-non-prod-credentials-switch`,
  getHalcyonPreAuthorizationSwitchId: fieldPath => `${fieldPath}.halcyon-pre-authorization-switch`,
  getHalcyonConditionalRulesSwitchId: fieldPath => `${fieldPath}.halcyon-conditional-rules-switch`,
  getHalcyonRuleDeleteButtonId: rulePath => `${rulePath}.delete-button`,
  getHalcyonAddRuleButtonId: fieldPath => `${fieldPath}.halcyon-add-rule-button`,

  // Wrapper (PrimaryDataWrapper) config action buttons
  getWrapperActionButtonId: index =>
    `${loanManagementTestIdsScope.CONTENT_VIEW}.action-button-${index}`,

  // LoanActionsGroup.utils (getTypeDependedFieldInputProps)
  getFieldValueSelectId: fieldPath => `${fieldPath}.value-select`,
  getFieldValueInputId: fieldPath => `${fieldPath}.value-input`,
  getFieldValueOptionId: fieldPath => `${fieldPath}.value-option`,

  // LoanActionImpoundRow
  getApplicationImpoundMonthlyAmountInputId: fieldPath => `${fieldPath}.monthly-amount-input`,
  getApplicationImpoundMonthlyAmountExpressionInputId: fieldPath =>
    `${fieldPath}.monthly-amount-expression-input`,
};
